import useCurrency from '@hooks/item/useCurrency';
import { GiftItemRow } from '@models/gift';
import { giftItemToGtmFormat, pushGtmEvent } from '@utils/gtm';
import { useEffect } from 'react';

function useViewGiftItem(giftItem?: GiftItemRow) {
    const currency = useCurrency();
    return useEffect(() => {
        if (giftItem) {
            pushGtmEvent({
                event: 'view_gift_item',
                value: giftItem.id,
                currency,
                items: [giftItemToGtmFormat({ gift: giftItem })],
            });
        }
    }, [giftItem, currency]);
}

export default useViewGiftItem;
